<!--
 * @Descripttion: 登录页面组件
 * @Author: congz
 * @Date: 2020-06-11 11:08:34
 * @LastEditors: congz
 * @LastEditTime: 2020-08-18 23:15:35
--> 

<template>
  <div class="payment">
    <div class="payment-content" v-if="order">
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="payment-clearfix">
          <span>Pay order</span>
        </div>
        <div class="payment-item">
          <div class="payment-tips">
            <span>Kind reminder: Your payment will be used as a donation and will not be shipped</span>
            <p>Attention: Please use UPI payment</p>
          </div>
          <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="payment-form">
            <el-form-item label="Donation amount" prop="amount">
              <el-select v-model="form.amount" placeholder="Please select the donation amount" clearable>
                <el-option label="No Donate" value="0"></el-option>
                <el-option label="1 INR " value="1"></el-option>
                <el-option label="10 INR " value="10"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="payment-paytype-header">
            <span>Payment Method</span>
          </div>
          <div class="payment-paytype">
            <div :class="form.pay_type=='alipay'? 'select':'no-select'" @click="selectAlipay">
              <a href="javascript:;">
                <img src="../assets/imgs/icon_upi.png" style="width: 100%;height: 100%" />
              </a>
            </div>

            <div :class="form.pay_type=='wechat'? 'select':'no-select'" @click="selectWechat">
              <a href="javascript:;">
                <img src="../assets/imgs/icon_paytm.png"  style="width: 100%;height: 100%"/>

              </a>
            </div>
          </div>
          <div class="pay-operate">
            <div class="pay-price">
              <span>order amount:</span>
            </div>
            <div class="pay-price-num">
              <span>{{order.discount_price*order.num}}₹</span>
            </div>
            <div class="should-pay">
              <span>Actual payable amount:</span>
            </div>
            <div class="pay-price-num">
              <span>{{form.amount}}₹</span>
            </div>
            <div class="pay-btn">
              <el-button type="primary" @click="pay('form')">Pay Now</el-button>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div class="not-found" v-else>Unable to find the order</div>
  </div>
</template>
<script>
import * as ordersAPI from '@/api/orders'
import * as paymentAPI from '@/api/payment'
export default {
  name: 'Payment',
  data() {
    return {
      orderNum: '',
      order: '',
      form: {
        order_num: '',
        amount: '',
        pay_type: 'alipay'
      },
      rules: {
        amount: [
          { required: true, message: 'Please select the donation amount', trigger: 'change' }
        ]
      }
    }
  },
  activated() {
    if (this.$route.query.orderNum != undefined) {
      this.orderNum = this.$route.query.orderNum
    }
  },
  watch: {
    // 监听商品id的变化，请求后端获取商品数据
    orderNum: function() {
      this.load()
    }
  },
  methods: {
    load() {
      ordersAPI
        .showOrder(this.orderNum)
        .then(res => {
          if (res.status === 200) {
            this.order = res.data
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to obtain order', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain order', err)
        })
    },
    selectWechat() {
      this.form.pay_type = 'wechat'
    },
    selectAlipay() {
      this.form.pay_type = 'alipay'
    },
    pay(formName) {
      // this.$refs[formName].validate(valid => {
      //   if (!valid) {
      //     return
      //   }
      //   this.form.order_num = String(this.orderNum)
      //   paymentAPI
      //     .initPayment(this.form)
      //     .then(res => {
      //       if (res.status === 200) {
      //         window.location.href = res.data.payUrl
      //       } else if (res.status === 20001) {
      //         //token过期，需要重新登录
      //         this.loginExpired(res.msg)
      //       } else {
      //         this.notifyError('Failed to obtain payment code', res.msg)
      //       }
      //     })
      //     .catch(err => {
      //       this.notifyError('Failed to obtain payment code', err)
      //     })
      // })
    }
  },
  created() {},
  components: {}
}
</script>

<style scoped>
.payment .payment-content {
  width: 800px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.payment .payment-content .payment-item .payment-tips {
  width: 600px;
  margin: 0 auto;
  text-align: center;
  color: #757575;
}
.payment .payment-content .payment-item .payment-form {
  width: 550px;
  margin: 0 auto;
  margin-top: 50px;
}
.payment .payment-content .payment-item .payment-paytype-header {
  width: 700px;
  margin: 0 auto;
  margin-top: 30px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}
.payment .payment-content .payment-item .payment-paytype {
  display: flex;
  align-items: center;
  height: 130px;
  width: 700px;
  margin: 0 auto;
  border-bottom: 1px solid #e0e0e0;
}
.payment .payment-content .payment-item .payment-paytype img {
  height: 60px;
  width: 240px;
}
.payment .payment-content .payment-item .payment-paytype .no-select {
  border-radius: 10px;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  margin-right: 50px;
}
.payment .payment-content .payment-item .payment-paytype .select {
  margin-right: 50px;
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid #1B2838;
}
.payment .payment-content .pay-operate {
  width: 700px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 60px;
}
.payment .payment-content .pay-operate .pay-price {
  margin-left: 170px;
  height: 20px;
}
.payment .payment-content .pay-operate .pay-price-num {
  font-size: 30px;
  color: #1B2838;
  width: 110px;
  margin-left: 10px;
}
.payment .payment-content .pay-operate .should-pay {
  margin-left: 20px;
  height: 20px;
}
.payment .payment-content .pay-operate .pay-btn {
  height: 30px;
}

/*v-else*/
.payment .not-found {
  height: 500px;
  text-align: center;
}
/*v-else END*/
</style>
